import { useClinic } from "@/components/Context/ClinicaContext";
import { AgendaService } from "@/services/ADM/AgendaService";
import { useQuery } from "@tanstack/react-query";

export const useRequisitosMinimos = () => {
  const { selectedClinic } = useClinic();
  const clinicaId = selectedClinic?._id;

  const requisitosAgendamentoQuery = useQuery({
    queryKey: [
      "verificarRequisitosAgendamento",
      clinicaId
    ],
    queryFn: () =>
      AgendaService.verificarRequisitosAgendamento({
        clinicaId
      }),
    enabled: !!clinicaId,
    refetchOnWindowFocus: false,
  });


  return {
    isClinic: !!selectedClinic,
    isLoading: requisitosAgendamentoQuery.isLoading,
    data: requisitosAgendamentoQuery.data,
  };
};
